import { store } from 'Store/store';
import {
  state,
  getters,
  actions,
  mutations
} from './NonPersistedStore.js';

if (!store.hasModule('bizgainOnboardingNonPersisted')) {
  store.registerModule('bizgainOnboardingNonPersisted', {
    state,
    getters,
    actions,
    mutations
  });
}